module.exports = __webpack_public_path__ + "static/fonts/rajdhani-medium-webfont.1f7e0b3.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-medium-webfont.woff2
// module id = 100
// module chunks = 0